import type { PropsWithChildren } from 'react';

import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import cn from '@/lib/utils/cn';

import { Tooltip, TooltipContent, TooltipTrigger } from '../shadcn/tooltip';

type Props = PropsWithChildren & {
  className?: string;
};

export default function AISparkles({ children, className }: Props) {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Sparkles className={cn('text-secondary-400 size-3.5', className)} />
      </TooltipTrigger>

      <TooltipContent side="bottom" className="max-w-52">
        {children ?? t('AI_CONTENT_GENERATED_LABEL')}
      </TooltipContent>
    </Tooltip>
  );
}
